import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";
import { Reveal } from "../lib/motion";

// Full-width yellow CTA — homepage only. Not a card; integrated edge-to-edge
// to create a strong transition into the footer.
export const HomeCta = () => {
  const { t } = useLang();
  const c = t.home.finalCta;

  return (
    <section className="w-full bg-accent-yellow text-ink" data-testid="home-cta">
      <Reveal>
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-8 md:py-10 text-center">
          <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight leading-[1.02]">
            {c.heading}
          </h2>
          <p className="mt-5 mx-auto max-w-xl md:max-w-none text-base md:text-lg text-ink/70 font-light leading-relaxed">
            {c.subtitle}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center items-stretch sm:items-center gap-4">
            <Link
              to="/devis"
              data-testid="home-cta-primary"
              className="inline-flex items-center justify-center px-8 py-4 rounded-xl bg-ink text-accent-yellow text-sm font-semibold hover:bg-ink/90 transition-colors duration-300"
            >
              {c.primary}
            </Link>
            <Link
              to="/rendez-vous"
              data-testid="home-cta-secondary"
              className="inline-flex items-center justify-center px-8 py-4 rounded-xl border border-ink/70 text-ink text-sm font-semibold hover:bg-ink hover:text-accent-yellow transition-colors duration-300"
            >
              {c.secondary}
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
